import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import TextField2 from "../textfields/TextField2.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
} from "../models/DataFunctions.js";

import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import sendErrorDiscord from "../api/sendErrorDiscord.js";
import moment from "moment";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import CurrencyField from "../textfields/CurrencyField.js";
import SmallSpinner from "../loading/SmallSpinner.js";

import PDF from "../pdf/PDF.js";
import { EasySwitch, ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import dayjs from "dayjs";
import { formatToEuro } from "../pages/NewInvoiceDraft.js";
import sendPennylaneSaveInvoiceReglement from "../api/pennylane/sendPennylaneSaveInvoiceReglement.js";

function AiExcelComparatif({
  folderData,
  navigateWorkspace,
  forcePageReload,
  onClose,
  orgData,
  userData,
}) {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [documents, setDocuments] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [step, setStep] = useState(0);
  const [sources, setSources] = useState([]);
  const [selectedSource, setSelectedSource] = useState({});
  const [items, setItems] = useState([]);
  const [images_extracted, setImagesExtracted] = useState([]);

  const [loadinFetch, setLoadingFetch] = useState(true);

  const handleFetchData = async () => {
    if (orgData) {
      try {
        console.log("Fetching documents for folder:", folderData);
        const token = await getOrRefreshFirebaseToken();
        await getTemporaryUrl(token, "all", null, folderData.id, prefix);
        let documents = await getArrayDocDataByRef(folderData.documents);
        if (folderData?.xml?.file?.id) {
          documents = [
            ...(documents || []),
            {
              name: folderData.xml.file.name,
              files: [folderData.xml.file],
            },
          ];
        }

        setDocuments(documents);
        setItems(orgData?.ai_extraction_config?.fields || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoadingFetch(false);
    }
  };

  const handleClearSource = () => {
    // remove extracted data for the selected source
    let clear_items = items.map((item) => {
      return { ...item, value_extracted: "" };
    });
    setItems(clear_items);
  };

  const [xml_data, setXmlData] = useState(null);

  const handleExtractXml = async () => {
    try {
      setLoadingFetch(true);
      // use formData to send to the api the selected source
      console.log("Selected source:", selectedSource);
      let fileInfo = sources.find(
        (s) => s.title === selectedSource?.title
      )?.file;
      console.log("File info:", fileInfo);
      let file_url = fileInfo.url;
      let file_name = fileInfo.name;
      // download the file from the url
      let response_file = await fetch(file_url);
      let blob = await response_file.blob();

      let file = new File([blob], file_name, { type: blob.type });

      let url = prefix + "ai-extraction-manual/xml";

      const formData = new FormData();

      formData.append("file", file);

      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + (await getOrRefreshFirebaseToken()),
        },
      });

      const data = await response.json();
      if (data.error) {
        handleClickVariant(data.error, "error");
        setLoadingFetch(false);
        return;
      }
      if (data) {
        setXmlData(data.data);
        let xml_items = [
          {
            title: "Adresse du maître d'ouvrage",
            value_extracted: data.data.maitre_ouvrage?.label || "",
          },
          {
            title: "Nom du maître d'ouvrage",
            value_extracted: data.data.maitre_ouvrage?.owner_name || "",
          },
          { title: "Nom du BET", value_extracted: data.data.bet?.nom || "" },
          // {
          //   title: "Adresse du BET",
          //   value_extracted: data.data.bet?.adresse || "",
          // },
          {
            title: "Adresse de l'opération",
            value_extracted: data.data.operation?.description || "",
          },
          {
            title: "Numéro de permis",
            value_extracted: data.data.operation?.num_permis || "",
          },
          {
            title: "Adresse de l'opération",
            value_extracted: data.data.operation?.adresse || "",
          },
          {
            title: "Surface de plancher (m²)",
            value_extracted: data.data.o_sref || "",
          },
          {
            title: "Surface habitable (m²)",
            value_extracted: data.data.o_shab || "",
          },
          {
            title: "Nombre de logements",
            value_extracted: data.data.nb_logement || "",
          },
          {
            title: "Ventilation mécanique",
            value_extracted: data.data.ventilation_mecanique || "",
          },
          {
            title: "Classe d'étanchéité des réseaux",
            value_extracted: data.data.classe_etancheite || "",
          },
          {
            title: "Hauteur de la zone (m)",
            value_extracted: data.data.hauteur_zone || "",
          },
          {
            title: "Q4 (m3/h/m²)",
            value_extracted: data.data.q4_pa_surf || "",
          },
          { title: "Volume (m3)", value_extracted: data.data.volumne || "" },

          {
            title: "Date du document",
            // transform YYYYMMDD to DD/MM/YYYY
            value_extracted: data.data.rset_entre_date
              ? `${data.data.rset_entre_date.slice(6, 8)}/${data.data.rset_entre_date.slice(4, 6)}/${data.data.rset_entre_date.slice(0, 4)}`
              : "",
          },
          {
            title: "Surface des parois extérieures hors plancher AT Bat",
            value_extracted: data.data.a_t_perm || "",
          },
        ];
        setSources(
          sources.map((s) =>
            s.title === selectedSource?.title
              ? { ...s, items: xml_items, extraction: 1.0 }
              : s
          )
        );
        setSelectedSource({
          ...selectedSource,
          items: xml_items,
          extraction: 1.0,
        });

        handleClickVariant("Données extraites avec succès", "success");
      } else {
        handleClickVariant("Erreur lors de l'extraction des données", "error");
      }
      setLoadingFetch(false);
    } catch (error) {
      console.error("Error extracting XML:", error);
      handleClickVariant("Erreur lors de l'extraction des données", "error");
      setLoadingFetch(false);
    }
  };

  const handleExtractPage = async (page_number, images) => {
    try {
      let imgs = images || images_extracted;
      setLoadingFetch(true);
      // use formData to send to the api the selected source
      console.log("Selected source:", selectedSource);
      let fileInfo = sources.find(
        (s) => s.title === selectedSource?.title
      )?.file;
      console.log("File info:", fileInfo);
      let file_url = fileInfo.url;
      let file_name = fileInfo.name;
      // download the file from the url
      let response_file = await fetch(file_url);
      let blob = await response_file.blob();
      let file = new File([blob], file_name, { type: blob.type });
      let url = prefix + "ai-extraction-manual/extract-page-image";
      const formData = new FormData();
      formData.append("file", file);
      formData.append("page_number", page_number);
      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + (await getOrRefreshFirebaseToken()),
        },
      });

      // Check if response is ok
      if (!response.ok) {
        const errorData = await response.text();
        handleClickVariant(
          errorData || "Erreur lors de l'extraction de la page",
          "error"
        );
        setLoadingFetch(false);
        return;
      }

      // Get the image blob directly
      const imageBlob = await response.blob();

      if (imageBlob && imageBlob.size > 0) {
        handleClickVariant("Page extraite avec succès", "success");

        let image = {
          url: URL.createObjectURL(imageBlob),
          name: `page_${page_number}.png`,
          size: `${Math.round(imageBlob.size / 1024)} Ko`,
          type: imageBlob.type || "image/png",
          tab_name: `page_${page_number}`,
        };

        setImagesExtracted([...imgs, image]);
        return [...imgs, image];
      } else {
        handleClickVariant("Erreur lors de l'extraction de la page", "error");
      }
      setLoadingFetch(false);
      return imgs;
    } catch (error) {
      console.error("Error extracting page:", error);
      handleClickVariant("Erreur lors de l'extraction de la page", "error");
      setLoadingFetch(false);
    }
  };

  const handleGenerateExcel = async () => {
    if (sources.length < 2) {
      handleClickVariant(
        "Veuillez sélectionner au moins deux sources pour générer le fichier excel",
        "error"
      );
      return;
    }

    setLoadingFetch(true);

    try {
      let url = prefix + "excel/create-excel";
      let comparative_table = generateComparaisonTable(sources);
      let file_name = `comparatif_${moment().format("DDMMYY_HHmmss")}.xlsx`;

      // Convert blob URLs to base64
      const images_with_base64 = await Promise.all(
        images_extracted.map(async (img) => {
          try {
            const response = await fetch(img.url);
            const blob = await response.blob();
            const base64 = await blobToBase64(blob);
            return {
              data: base64, // Send base64 instead of URL
              tab_name: img.tab_name,
              name: img.name,
            };
          } catch (error) {
            console.error(`Failed to convert image ${img.name}:`, error);
            return null;
          }
        })
      );

      // Filter out any failed conversions
      const valid_images = images_with_base64.filter((img) => img !== null);

      const token = await getOrRefreshFirebaseToken();
      const body = {
        folder_id: folderData.id,
        columns: ["donnée", sources[0].title, sources[1].title],
        column_widths: [50, 50, 50],
        rows: comparative_table.map((item) => ({
          data: [item.title, item.value1, item.value2],
          backgroundColor: "#ffffff",
        })),
        file_name: file_name,
        images: valid_images,
      };

      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      const data = await response.json();

      if (data.error) {
        handleClickVariant(data.error, "error");
        return;
      }

      if (data.url) {
        window.open(data.url, "_blank");
        handleClickVariant("Fichier excel généré avec succès", "success");
      } else {
        handleClickVariant(
          "Erreur lors de la génération du fichier excel",
          "error"
        );
      }
    } catch (error) {
      console.error("Error generating Excel:", error);
      handleClickVariant(
        "Erreur lors de la génération du fichier excel",
        "error"
      );
    } finally {
      setLoadingFetch(false);
    }
  };

  // Helper function to convert blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleExtractSource = async () => {
    setLoadingFetch(true);
    // use formData to send to the api the selected source
    console.log("Selected source:", selectedSource);
    let fileInfo = sources.find((s) => s.title === selectedSource?.title)?.file;
    console.log("File info:", fileInfo);
    let file_url = fileInfo.url;
    let file_name = fileInfo.name;
    // download the file from the url
    let response_file = await fetch(file_url);
    let blob = await response_file.blob();

    let file = new File([blob], file_name, { type: blob.type });

    let url = prefix + "ai-extraction-manual/pdf";

    const formData = new FormData();

    formData.append("file", file);

    formData.append("items", JSON.stringify(items));
    formData.append(
      "source_type",
      file_name.includes(".pdf")
        ? "pdf"
        : file_name.includes(".xml")
          ? "xml"
          : "other"
    );
    formData.append("folder_id", folderData.id);
    formData.append("org_id", orgData.id);
    formData.append("user_id", userData.id);

    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Bearer " + (await getOrRefreshFirebaseToken()),
      },
    });

    const data = await response.json();
    if (data.error) {
      handleClickVariant(data.error, "error");
      setLoadingFetch(false);
      return;
    }
    if (data.items) {
      setSources(
        sources.map((s) =>
          s.title === selectedSource?.title
            ? {
                ...s,
                items: data.items,

                extraction: 1.0,
              }
            : s
        )
      );
      setSelectedSource({
        ...selectedSource,
        items: data.items,
        extraction: 1.0,
      });

      let new_images = await handleExtractPage(13);
      await handleExtractPage(19, new_images);

      handleClickVariant("Données extraites avec succès", "success");
    } else {
      handleClickVariant("Erreur lors de l'extraction des données", "error");
    }
    setLoadingFetch(false);
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  return (
    <div className="flex flex-col  bg-white rounded-3xl   w-full max-w-c900 h-fit overflow-auto max-h-c600">
      <div className="flex text-h3 justify-between items-center p-4 border-b border-neutral-200">
        <div className="">Génération d'un excel comparatif</div>
        <div className="text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>
      {step === 0 && (
        <>
          <div className="flex flex-col gap-2 p-4 bg-neutral-50">
            <div className="w-c300 text-h3 text-shadow_50">
              Sélectionnez les sources de données pour générer un excel
              comparatif
            </div>

            <div className="flex flex-col gap-2 max-h-c300 overflow-auto">
              {documents.map((doc, index) => (
                <div key={index}>
                  {doc?.files?.map((docFile, docIndex) => (
                    <div
                      key={docIndex}
                      className={`
                      ${
                        sources.map((s) => s.title).includes(docFile.name)
                          ? "bg-indigo-50"
                          : "hover:bg-indigo-50"
                      }
                      flex flex-row items-center pr-4 text-h3 p-2 rounded-xl`}
                    >
                      <div
                        className={`
              bg-gradient-to-tr from-indigo-300 to-indigo-100 
                  p-1 h-fit w-fit  rounded-2xl `}
                      >
                        <div
                          className="rounded-xl h-c75 w-14  bg-white   cursor-pointer flex items-center
               justify-center"
                        >
                          <Icon1
                            icon_name={
                              docFile?.name.includes("pdf")
                                ? "file"
                                : docFile?.name.includes("xml")
                                  ? "code"
                                  : "file"
                            }
                            size={25}
                            fill="#a5b4fc"
                            className="text-indigo-300 "
                          />
                        </div>{" "}
                      </div>
                      <div className="flex flex-col ml-4">
                        <div className=" mt-2">{docFile.name}</div>
                        <div className=" text-neutral-400">
                          {Math.round(docFile.octets / 1024)} Ko
                        </div>
                      </div>
                      <div className="ml-auto">
                        <CheckBoxGrey
                          checked={sources
                            .map((s) => s.title)
                            .includes(docFile.name)}
                          onChange={() => {
                            if (
                              sources.map((s) => s.title).includes(docFile.name)
                            ) {
                              setSources(
                                sources.filter((s) => s.title !== docFile.name)
                              );

                              if (selectedSource?.title === docFile.name) {
                                setSelectedSource({
                                  title: "Fichier excel",
                                });
                              }
                            } else {
                              setSources([
                                ...sources,
                                {
                                  title: docFile.name,
                                  file: {
                                    name: docFile.name,
                                    size: `${Math.round(
                                      docFile.octets / 1024
                                    )} Ko`,
                                    url: docFile.url,

                                    type: docFile.contentType,
                                  },
                                  extraction: 0.0,
                                },
                              ]);
                              setSelectedSource(docFile);
                            }
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row  justify-end p-4 border-t-1">
            <PrimaryButton className={"w-fit"} onClick={() => setStep(1)}>
              Continuer
            </PrimaryButton>
          </div>
        </>
      )}
      {step === 1 && (
        <>
          <div className="flex flex-row ">
            <div className="flex flex-col gap-2  border-r-1 p-2 bg-neutral-50 ">
              {sources.map((item, index) => (
                <div
                  onClick={() => setSelectedSource(item)}
                  key={index}
                  className={`flex flex-row text-h4  
                
                cursor-pointer rounded-xl p-2
            ${item.title === selectedSource?.title ? " bg-indigo-100  " : "hover:bg-indigo-50"}
            `}
                >
                  <div
                    className={`
              bg-gradient-to-tr from-indigo-300 to-indigo-100
                 p-1 h-fit w-fit  rounded-2xl `}
                  >
                    <div
                      className="rounded-xl h-c75 w-16  bg-white   cursor-pointer flex items-center
               justify-center"
                    >
                      <Icon1
                        icon_name="file"
                        size={25}
                        fill="#a5b4fc"
                        className="text-indigo-300 text-h2"
                      />
                    </div>{" "}
                  </div>
                  <div className="flex flex-col ml-4 w-40">
                    <div className=" mt-2">{item.title.substring(0, 20)}</div>
                    <div className=" text-neutral-400">
                      {item.file.name.includes(".pdf")
                        ? "Fichier PDF"
                        : item.file.name.includes(".xml")
                          ? "Fichier XML"
                          : "Fichier"}{" "}
                      - {item.file.size}
                    </div>
                    <div className="w-40 h-1 bg-white rounded-full mt-2">
                      <div
                        className="h-1 bg-indigo-400 rounded-full"
                        style={{ width: `${item.extraction * 100}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
              {images_extracted.map((img, index) => (
                <div
                  key={index}
                  className={`flex flex-row text-h4
                cursor-pointer rounded-xl p-2 `}
                >
                  <div
                    className={`
              bg-gradient-to-tr from-purple-300 to-purple-100
                 p-1 h-fit w-fit  rounded-2xl `}
                  >
                    <div
                      className="rounded-xl h-c75 w-16  bg-white   cursor-pointer flex items-center
               justify-center"
                    >
                      <Icon1
                        icon_name="image"
                        size={25}
                        fill="#d8b4fc"
                        className="text-purple-300 text-h2"
                      />
                    </div>{" "}
                  </div>
                  <div className="flex flex-col ml-4 w-40">
                    <div className=" mt-2">Image extraite</div>
                    <div className=" text-neutral-400">
                      {img.name} - {img.size}
                    </div>
                    <div className="w-40 h-1 bg-white rounded-full mt-2">
                      <div
                        className="h-1 bg-purple-400 rounded-full"
                        style={{ width: `100%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="w-full pl-7 flex flex-row  items-center">
                <Icon1 icon_name="down" fill="grey" size={25} />
              </div>
              <div
                onClick={() =>
                  setSelectedSource({
                    title: "Fichier excel",
                  })
                }
                className={`
          ${selectedSource === "Fichier excel" ? " bg-indigo-100  " : "hover:bg-indigo-50"}
          flex flex-row text-h4 p-2 rounded-xl cursor-pointer  `}
              >
                <div
                  className={`
               
                bg-gradient-to-tr from-green-500 to-green-100 p-1 h-fit w-fit rounded-2xl `}
                >
                  <div
                    className="rounded-xl h-c75 w-16  bg-white   flex items-center
               justify-center"
                  >
                    <Icon1
                      icon_name="excel"
                      size={25}
                      fill="#a5b4fc"
                      className="text-indigo-300 text-h2"
                    />
                  </div>{" "}
                </div>
                <div className="flex flex-col ml-4 w-40">
                  <div className=" mt-2">{"Fichier excel"}</div>
                  <div className=" text-neutral-400">
                    Le fichier excel comparatif sera généré
                  </div>
                </div>
              </div>
            </div>
            {selectedSource?.title === "Fichier excel" &&
              sources.length >= 2 && (
                <div className="flex flex-col gap-4  bg-neutral-100 p-4 overflow-auto max-h-c400 w-full">
                  <div className="text-h3 mb-2 flex flex-row gap-2 items-center justify-between">
                    Génération du fichier excel{" "}
                  </div>

                  <div className="flex flex-col ">
                    <div className="flex flex-col text-h4 w-full">
                      <table className="w-full border-collapse">
                        <thead>
                          <tr className="border-b-2 border-neutral-300">
                            <th className="text-left p-1 font-bold min-w-c200">
                              Donnée
                            </th>
                            <th className="text-left p-1 font-bold text-neutral-400">
                              {sources[0].title}
                            </th>
                            <th className="text-left p-1 font-bold text-neutral-400">
                              {sources[1].title}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {generateComparaisonTable(sources).map(
                            (item, index) => (
                              <tr
                                key={index}
                                className={`border-b border-neutral-200 ${
                                  item.different ? "" : ""
                                }`}
                              >
                                <td className="p-1 min-w-c200">{item.title}</td>
                                <td className="p-1 text-neutral-400 italic">
                                  {item.value1}
                                </td>
                                <td className="p-1 text-neutral-400 italic">
                                  {item.value2}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            {selectedSource?.title !== "Fichier excel" && (
              <div className="flex flex-col gap-4  bg-neutral-100 p-4 overflow-auto max-h-c400 w-full">
                <div className="text-h3 mb-2 flex flex-row gap-2 items-center justify-between">
                  Données à extraire{" "}
                  <SecondaryButton
                    onClick={() => {
                      navigateWorkspace("/extraction-ia");
                    }}
                  >
                    Configurer
                  </SecondaryButton>
                </div>

                <div className="flex flex-col ">
                  {selectedSource?.items?.map((item, index) => (
                    <div key={index} className="flex flex-col text-h4 w-full">
                      <div className="flex flex-row gap-2">
                        <div className="  min-w-c200 w-c200">{item.title}</div>

                        <div className="text-body text-neutral-400 italic">
                          {item.value_extracted}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-row  justify-end gap-2 p-4 border-t-1">
            <SecondaryButton className={"w-fit "} onClick={() => setStep(0)}>
              Retour
            </SecondaryButton>
            {selectedSource?.title === "Fichier excel" && (
              <PrimaryButton className={"w-fit"} onClick={handleGenerateExcel}>
                Générer le fichier excel <SmallSpinner loading={loadinFetch} />
              </PrimaryButton>
            )}
            {selectedSource?.title !== "Fichier excel" && (
              <PrimaryButton
                className={"w-fit"}
                onClick={() => handleExtractPage(13)}
              >
                Page 13 <SmallSpinner loading={loadinFetch} />
              </PrimaryButton>
            )}{" "}
            {selectedSource?.title !== "Fichier excel" && (
              <PrimaryButton
                className={"w-fit"}
                onClick={() => handleExtractPage(19)}
              >
                Page 19
                <SmallSpinner loading={loadinFetch} />
              </PrimaryButton>
            )}
            {selectedSource?.title !== "Fichier excel" && (
              <PrimaryButton
                className={"w-fit"}
                onClick={() =>
                  selectedSource?.title?.includes(".xml")
                    ? handleExtractXml()
                    : handleExtractSource()
                }
              >
                Extraire les données <SmallSpinner loading={loadinFetch} />
              </PrimaryButton>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default AiExcelComparatif;

export const generateXmlTable = (xml_data) => {
  return (
    <div className="flex flex-col text-h4 w-full">
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-col">
          <div className="flex flex-row gap">
            <div className="  min-w-c200 ">Adresse du maitre d'ouvrage : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.maitre_ouvrage?.label}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Nom du maitre d'ouvrage : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.maitre_ouvrage?.owner_name}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Nom du BET : </div>
            <div className="text-neutral-400 italic ">{xml_data.bet?.nom}</div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200 ">Adresse du BET : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.bet?.adresse}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className=" min-w-c200 ">Description de l'opération :</div>
            <div className="text-neutral-400 italic ">
              {xml_data.operation?.description}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Numéro de permis : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.operation?.num_permis}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Adresse de l'opération : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.operation?.adresse}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Surface de plancher (m²) : </div>
            <div className="text-neutral-400 italic ">{xml_data.o_sref}</div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Surface habitable (m²) : </div>
            <div className="text-neutral-400 italic ">{xml_data.o_shab}</div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Nombre de logements : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.nb_logement}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Ventilation mécanique : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.ventilation_mecanique}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Classe d'étanchéité : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.classe_etancheite}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200"></div>
            <div className="text-neutral-400 italic ">{xml_data.a_t_perm}</div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Hauteur de la zone (m) : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.hauteur_zone}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Q4 (m3/h/m² SHON) : </div>
            <div className="text-neutral-400 italic ">
              {xml_data.q4_pa_surf}
            </div>
          </div>
          <div className="flex flex-row gap">
            <div className="  min-w-c200">Volume (m3) : </div>
            <div className="text-neutral-400 italic ">{xml_data.volumne}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const generateComparaisonTable = (sources) => {
  // compare 2 first sources items and display differences
  if (sources.length < 2) {
    return (
      <div className="text-h4 text-neutral-400">
        Sélectionnez au moins 2 sources pour générer un comparatif
      </div>
    );
  }

  let source1 = sources[0];
  let source2 = sources[1];

  if (!source1.items || !source2.items) {
    return (
      <div className="text-h4 text-neutral-400">
        Les données n'ont pas encore été extraites, lancez l'extraction pour
        chaque source.
      </div>
    );
  }

  // Get all unique titles from both sources
  const allTitles = new Set([
    ...source1.items.map((item) => item.title),
    ...source2.items.map((item) => item.title),
  ]);

  // Create merged items including items that exist in only one source
  let mergedItems = Array.from(allTitles).map((title) => {
    const item1 = source1.items.find((item) => item.title === title);
    const item2 = source2.items.find((item) => item.title === title);

    const value1 = item1 ? item1.value_extracted : "";
    const value2 = item2 ? item2.value_extracted : "";

    return {
      title: title,
      value1: value1,
      value2: value2,
      different: item1 && item2 ? value1 !== value2 : true,
    };
  });

  return mergedItems;
};
